import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CustomTableComponent, ICustomTable,
  CustomTitle, DataColumnType, ISettings, ButtonColumnType,
  IsearchJefeHogar} from "lib-base";
import { TranslateService} from "@ngx-translate/core";
import {firstValueFrom, forkJoin} from "rxjs";
import {InputTextModule} from "primeng/inputtext";
import { INucleoFamiliar } from '../../shared/interface/sisben';


@Component({
  selector: 'app-informacion-sisben',
  standalone: true,
  imports: [CustomTableComponent, CustomTitle, InputTextModule],
  templateUrl: './informacion-sisben.component.html',
  styleUrl: './informacion-sisben.component.scss'
})
export class InformacionSisbenComponent implements OnInit, AfterViewInit {

  @Input() props: IsearchJefeHogar | undefined;
  @Output('editEmitter') editEventEmitter: EventEmitter<INucleoFamiliar> = new EventEmitter();
  @Output('deleteEmitter') deleteEventEmitter: EventEmitter<INucleoFamiliar> = new EventEmitter();

  @Input() modificar: boolean = false;
  @Input() eliminar: boolean = false;

  _translations: any = {};
  configTable!: ICustomTable;
  _jefeHogar: INucleoFamiliar | undefined;
  private _nucleoFamiliar!: INucleoFamiliar[] | null;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;


  constructor(private _t: TranslateService) {
  }

  ngOnInit(): void {
    this.getTranslations()
      .then(() => this.getConfigTable());
  }

  ngAfterViewInit(): void {
    if (this.customTableComponent && !this._nucleoFamiliar) {
      setTimeout(() => {
        this.customTableComponent.data = [];
      }, 300)
    }

  }


  private async getTranslations(): Promise<void> {
    this._translations = await firstValueFrom(forkJoin({
      aceptar: this._t.get('form.button.aceptar'),
      cargando: this._t.get('msg.cargando'),

    }));
  }

  private getConfigTable() {
    this.configTable = {
      columns: [
        {
          field: 'primerNombre',
          header: 'Primer nombre',
          class: 'font-13 py-3',
          width: '15em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'primerApellido',
          header: 'Primer apellido',
          class: 'font-13 py-3',
          width: '15em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tipoIdentificacionDescripcion',
          header: 'Tipo identificación',
          class: 'font-13 py-3',
          width: '22em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'identificacion',
          header: 'Identificación',
          class: 'font-13 py-3',
          width: '22em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'generoDescripcion',
          header: 'Genero',
          class: 'font-13 py-3',
          width: '22em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'vinculoDescripcion',
          header: 'Vinculo',
          class: 'font-13 py-3',
          width: '22em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        }
      ],
      settings: {
        table: {
          rows: 8,
          lazy: true
        }
      } as ISettings
    } as ICustomTable;

    if (this.modificar) {
      this.configTable.columns.push({
        field: 'edit',
        header: '',
        width: '0rem',
        class: 'pt-2 pb-2 pr-1',
        buttonType: ButtonColumnType.EDIT,
        onClick: (event: any, data: INucleoFamiliar) =>
          this.editEventEmitter.emit(data)


      });
    }
    if (this.eliminar) {
      this.configTable.columns.push({
        field: 'delete',
        header: '',
        width: '0rem',
        class: 'pt-2 pb-2 pr-1',
        buttonType: ButtonColumnType.DELETE,
        onClick: (event: any, data: INucleoFamiliar) =>
          this.deleteEventEmitter.emit(data)
      });
    }
  }

  clearData(): void {
    this.props = undefined;
    this._jefeHogar = undefined;
    if (this.customTableComponent)
      this.customTableComponent.data = [];
    this._nucleoFamiliar = [];
  }

  public setNucleoFamiliar(data: INucleoFamiliar[] | null) {
    if (this.customTableComponent) {
      this._nucleoFamiliar = data;
      this.customTableComponent.data = data ?? [];
    }
  }

  public setInformacioJefeHogar(data: INucleoFamiliar | undefined) {
    this._jefeHogar = data;
  }

}
